var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingPageBackgroundRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1346,
    height: 533,
    viewBox: "0 0 1346 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1300 -51C1248.85 382.93 845.657 311.785 896.986 191.642C948.316 71.4987 1123.92 215.199 1099.3 329.04C1074.69 442.882 973.71 521.918 840.794 446.063C707.878 370.208 774.336 271.737 503.101 271.737C231.866 271.737 271.309 441.822 393.959 437.111C516.609 432.399 597.841 185 295.082 153.008C52.8751 127.414 46 -51 46 -51",
    stroke: "#E2E6E5",
    strokeWidth: 92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 -51C1248.85 382.93 845.657 311.785 896.986 191.642C948.316 71.4987 1123.92 215.199 1099.3 329.04C1074.69 442.882 973.71 521.918 840.794 446.063C707.878 370.208 774.336 271.737 503.101 271.737C231.866 271.737 271.309 441.822 393.959 437.111C516.609 432.399 597.841 185 295.082 153.008C52.8751 127.414 46 -51 46 -51",
    stroke: "white",
    strokeWidth: 85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 -51C1248.85 382.93 845.657 311.785 896.986 191.642C948.316 71.4987 1123.92 215.199 1099.3 329.04C1074.69 442.882 973.71 521.918 840.794 446.063C707.878 370.208 774.336 271.737 503.101 271.737C231.866 271.737 271.309 441.822 393.959 437.111C516.609 432.399 597.841 185 295.082 153.008C52.8751 127.414 46 -51 46 -51",
    stroke: "#E2E6E5",
    strokeWidth: 79
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 -51C1248.85 382.93 845.657 311.785 896.986 191.642C948.316 71.4987 1123.92 215.199 1099.3 329.04C1074.69 442.882 973.71 521.918 840.794 446.063C707.878 370.208 774.336 271.737 503.101 271.737C231.866 271.737 271.309 441.822 393.959 437.111C516.609 432.399 597.841 185 295.082 153.008C52.8751 127.414 46 -51 46 -51",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeDasharray: "17.37 17.37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingPageBackgroundRoad);
export default __webpack_public_path__ + "static/media/marketing-page-background-road.e381d719a8dfd74fa925695605c0a634.svg";
export { ForwardRef as ReactComponent };